import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import { StringFormatter } from '@repo/toolkit/string'
import { toFullName } from '@repo/toolkit/to-full-name'
import Badge from '@repo/ui/badge'
import InnerBox from '@repo/ui/inner-box'

import useTranslate from '../../lib/hooks/use-translate'
import { olStaffPositionEnumMapping } from '../../lib/types/enums/staff/staff-position.enum'
import {
  getOlStaffQualificationLabel,
  StaffQualificationEnum
} from '../../lib/types/enums/staff/staff-qualifications.enum'
import { Staff } from '../../lib/types/models/staff/staff'
import { formatPhoneNumber } from '../../utils/functions/format-phone-number'
import LabelWithText from './label-with-text'

type Props = {
  staff: Pick<Staff, 'firstName' | 'lastName' | 'birthDate' | 'phoneNumber' | 'position'> & {
    picture?: Pick<NonNullable<Staff['picture']>, 'path'> | null
    user: Pick<Staff['user'], 'email'>
  }
  qualification: StaffQualificationEnum
  className?: string
}

const StaffProfileCard = ({ staff, qualification, className }: Props) => {
  const { t } = useTranslate()
  return (
    <div className={className}>
      <InnerBox className={'rounded-lg p-3'}>
        <div className="flex gap-3 items-start ">
          <img
            className="rounded h-[90px] w-[90px] object-cover"
            src={staff.picture ? staff.picture.path : '/profile-default.jpg'}
            alt={toFullName(staff.firstName, staff.lastName)}
          />
          <div className="flex flex-col gap-2">
            <Badge
              text={t(olStaffPositionEnumMapping[staff.position])}
              color={tailwindColors.purple.light.DEFAULT}
              textColor={tailwindColors.purple.DEFAULT}
            />
            <div className="grid grid-cols-3 gap-2">
              <LabelWithText data={staff.lastName.toUpperCase()} label={'Nom'} />
              <LabelWithText data={StringFormatter.capitalize(staff.firstName)} label={'Prénom'} />
              <div />
              <LabelWithText
                data={DateFormatter.DDMMYYYY(staff.birthDate)}
                label={'Date de naissance'}
              />
              <LabelWithText data={DateFormatter.calculateAge(staff.birthDate)} label={'Âge'} />
              <div />
              <LabelWithText
                data={formatPhoneNumber(staff.phoneNumber)}
                label={'Téléphone personnel'}
              />
              <LabelWithText data={staff.user.email} label={'Email'} />
              <div />
              <LabelWithText
                className="col-span-3"
                data={t(getOlStaffQualificationLabel(qualification))}
                label={'Qualification'}
              />
            </div>
          </div>
        </div>
      </InnerBox>
    </div>
  )
}

export default StaffProfileCard
